import React, { useState } from 'react';
import Button from '../../../../components/common/ui-components/input/Button';
import styles from './intro.module.scss';
import dynamic from 'next/dynamic';
import { cleverTapTrigger } from '../../../../tracking/segment';

const ReactPlayer = dynamic(()=> import("react-player"),
    {loading: () => <p>Loading ...</p>,ssr:false }
);

const Intro = (props) => {
    const [isMuted, setIsMuted] = useState(true)

    const link = 'https://salespro.app.link/nrkz4MkWgDb'

    const scrollToForm = () => {
        cleverTapTrigger("Get In Touch Clicked", {})
        const a: any = document.querySelector(`#name`)
        const b: any = document.querySelector(`#getInTouch`)
        b?.scrollIntoView({behavior: 'smooth', block: 'center'})
        setTimeout(() => { a?.focus() }, 1000)   
    }

    const downloadApp = () => {
        cleverTapTrigger("Download Salespro Clicked", {})
        window.open(link, '_blank', "noopener,noreferrer")
        window.opener = null
    }
    
    return (
    <>
        <div className={styles.parent_container}>
                <div className={`${styles.grid_item} ${styles.item_1}`}>
                    <div className={`${styles.header_content}`}>
                        <p>Maximize your </p>
                        <p><span className={styles.highlight}>Business </span>Potential</p>
                        <p> with Salespro</p>
                    </div>
                    <p className={styles.description}>
                            Why limit yourself to a single source of income? 
                            You can earn more on every sale you make with Salespro, 
                            our partner's app! By offering our plans via Salespro, 
                            you can increase your income while also taking care of your customers.
                    </p>
                </div>
                <div className={`${styles.infograph} ${styles.grid_item} ${styles.item_2} row`}>
                    <div className={`col-4`}>
                        <div className={`${styles.sprite} ${styles.brands}`}></div>
                        <span className={`${styles.infograph_item}`}>300+</span>
                        <p>Brands Covered</p>
                    </div>
                    <div className={`col-4`}>
                    <div className={`${styles.sprite} ${styles.stores}`}></div> 
                        <span className={`${styles.infograph_item}`}>10,000+</span>
                        <p>Retail-Store Presence</p>
                    </div >
                    <div className={`col-4`}>
                    <div className={`${styles.sprite} ${styles.revenue}`}></div>
                        <span className={`${styles.infograph_item}`}>10+</span>
                        <p>Lakh Revenue</p>
                    </div>
                </div>
                <div className={`${styles.cta_buttons} ${styles.grid_item} ${styles.item_3}`}>
                        <Button className={`${styles.get_in_touch} ${styles.button}`} onClick={scrollToForm}>Get in Touch</Button>
                        <Button className={`${styles.download_app} ${styles.button}`} onClick={downloadApp}>Download App</Button>
                </div>
            <div className={`${styles.intro_video} ${styles.grid_item} ${styles.item_4}`}>
                <ReactPlayer 
                    url="https://www.youtube.com/watch?v=VfDKxtV262U&autoplay=1"
                    playing={props.videoPlaying && props.video=='intro'}
                    muted={isMuted}
                    className={styles.video_player}
                    height="100%"
                    width="100%"
                    onPause={() => {setIsMuted(false)}}
                    onPlay={() => {props.setVideo('intro')}}
                />
            </div>
        </div>
    </>
    );
}


export default Intro;